export default {
  ERROR: 'ERROR',
  TYPES: {
    GRAPHQL_ERROR: 'graphql_error',
    LOAD_USER_ERROR: 'unable_to_load_user_data',
    COMPONENT_ERROR: 'component_error'
  },
  ADJUST_MODAL: {
    CLICKED_ADJUST_JOB: 'CLICKED_ADJUST_JOB'
  },
  CLICKED_EXPORT_ROSTER: 'CLICKED_EXPORT_ROSTER',
  CLICKED_QUICK_REPORTS: 'CLICKED_QUICK_REPORTS'
};
